module.exports = __webpack_public_path__ + "static/media/BackgroundImg.cd1a6816.jpg";